import { Link } from "react-router-dom";
import { Snowflake } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useProspectForLead } from "@/hooks/useProspects";
import { formatProspectValue } from "@/lib/prospectDisplay";
import { safeHttpUrl } from "@/lib/safeUrl";

/**
 * No detalhe do lead: de qual lista de leads frios ele veio e as colunas
 * personalizadas que foram coletadas na prospecção (somente leitura). Não
 * renderiza nada para lead que não veio de prospecção.
 */
export interface ProspectOriginCardProps {
  leadId: string;
}

export function ProspectOriginCard({ leadId }: ProspectOriginCardProps) {
  const { data } = useProspectForLead(leadId);
  if (!data) return null;
  const { prospect, listName, fields } = data;
  const filled = fields.filter((f) => {
    const v = prospect.data[f.key];
    return v !== null && v !== undefined && v !== "";
  });
  const links = [prospect.website, prospect.instagram]
    .map((u) => (u ? safeHttpUrl(u) : null))
    .filter((u): u is string => !!u);

  return (
    <Card className="rounded-2xl shadow-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 font-display text-base">
          <Snowflake className="h-4 w-4 text-info" aria-hidden="true" /> Origem: lead frio
        </CardTitle>
        <Link
          to={`/admin/leads-frios?list=${prospect.list_id}`}
          className="text-[12.5px] text-primary hover:underline"
        >
          {listName}
        </Link>
      </CardHeader>
      <CardContent className="flex flex-col gap-2.5 text-[13px]">
        {links.map((href) => (
          <a
            key={href}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="truncate text-primary hover:underline"
          >
            {href.replace(/^https?:\/\//, "")}
          </a>
        ))}
        {filled.length === 0 && links.length === 0 && (
          <p className="text-muted-foreground">Sem dados extras da prospecção.</p>
        )}
        <dl className="flex flex-col gap-2">
          {filled.map((f) => (
            <div key={f.id}>
              <dt className="text-[11px] text-muted-foreground">{f.label}</dt>
              <dd className="whitespace-pre-wrap break-words">
                {formatProspectValue(f, prospect.data[f.key])}
              </dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
